import api from './api';
import {setToken} from './servicesGetCookie';

export const PostSaveMyPost = async (ObjDadosDoPost) => {
    let dividindoImage = ObjDadosDoPost.Image1.split('/');
    let imagem = dividindoImage[dividindoImage.length - 1];
    if(imagem === 'undefined')
        return {status:400,error:'Nome da imagem'+imagem}
    try {
        const AUTH_TOKEN = setToken();
        let resposta = await api.post(`saveMyPost`,{
            Id:ObjDadosDoPost.Id,
            PostTitle:ObjDadosDoPost.PostTitle ,
            Image1:`https://medxdata.blob.core.windows.net/medxsocial/${imagem}`,
            KeyWords:ObjDadosDoPost.KeyWords ,
            PopularCount:ObjDadosDoPost.PopularCount ,
            Date:ObjDadosDoPost.Date ,
            Category:ObjDadosDoPost.Category ,
            PostText:ObjDadosDoPost.PostText ,
        },{'headers':{'Authorization':`Bearer ${AUTH_TOKEN}`}} );
        return resposta;
    } catch (error) {

            return {status:error.response.status,error:'Não foi possível salvar o post'};

    }
};
